import { useRouter } from "next/router";

export function getJobMetaInfo(str: string): { qualification: string; experience: string; type: string } {
    const fields = str?.split(";");
    let metaInfo = {} as any;
    metaInfo["qualification"] = fields?.find((f) => f.match("qualification"))?.split("=")[1];
    metaInfo["experience"] = fields?.find((f) => f.match("experience"))?.split("=")[1];
    metaInfo["type"] = fields?.find((f) => f.match("type"))?.split("=")[1];
    return metaInfo;
}

const x = (id: string) => {
    const section = document.querySelector(`#${id}`);
    if (section) {
        section.scrollIntoView();
        window.scrollBy(0, -74);
        return;
    } else {
        setTimeout(() => {
            x(id);
        }, 1);
    }
};

export async function navToSection(id: string, router: ReturnType<typeof useRouter>) {
    // router.push("/careers");
    x(id);
    // await sleep(200);
    // document.querySelector(`#${id}`)?.scrollIntoView();
    // window.scrollBy(0, -+getHeightByViewPort(74).slice(0, -2));
}
